import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import Container from './Container';
import CloudinaryImage from './CloudinaryImage';

export default function CloudDeployment({ CloudDeployment, colorChange }) {
  return (
    <Container className={colorChange ? 'text-[#00102B]' : 'text-white'}>
      {CloudDeployment?.title && (
        <div className="lg:mb-[34px] mb-[30px]">
          <h6 className="xl:text-[55px] font-[800] md:text-[32px] text-[25px] leading-tight mb-3">
            {CloudDeployment?.title}
          </h6>
          <p className="md:text-[20px] text-[14px] font-[400] leading-tight">
            {CloudDeployment?.description}
          </p>
        </div>
      )}

      <div
        className={`${colorChange ? 'text-[#000A1C]' : 'text-white'} grid md:grid-cols-2 grid-cols-1 gap-10`}
      >
        {CloudDeployment?.reasonList?.map(CloudDeploymentData => (
          <div
            key={CloudDeploymentData?.id}
            className={`px-5 py-8 grid grid-cols-12 md:gap-0 gap-2 rounded-[20px] ${colorChange ? 'bg-[#E8F1FF]' : 'bg-[linear-gradient(181.1deg,_#12141A_14.3%,_#62207E_262.06%)]'}`}
          >
            <div className="md:col-span-2 col-span-2 text-[18px] font-[700] text-[#FFFFFF]">
              {CloudDeploymentData?.image?.data &&
                CloudDeploymentData?.image?.data?.map(img => (
                  <div key={img?.id}>
                    <CloudinaryImage
                      backendImgUrl={img?.attributes?.url}
                      className={`w-[60px] h-[60px]`}
                      alt={img?.attributes?.alternativeText}
                      type="icon"
                    />
                  </div>
                ))}
            </div>
            <div className="md:col-span-10 col-span-10">
              <h4
                className={`lg:text-[22px] text-[18px] font-[600] mb-2 ${colorChange ? 'text-[#000]' : 'text-[#fff]'}`}
              >
                {CloudDeploymentData?.title}
              </h4>
              {CloudDeploymentData?.description && (
                <p
                  className={`${colorChange ? 'text-[#383838]' : 'text-[#f5f5f5]'} md:text-[16px] text-[14px] font-[400] leading-tight`}
                >
                  {CloudDeploymentData?.description}
                </p>
              )}
              {CloudDeploymentData?.editor && (
                <ReactMarkdown
                  rehypePlugins={[rehypeRaw]}
                  className={`${colorChange ? 'text-[#383838]' : 'text-[#f5f5f5]'} md:text-[16px] text-[14px] font-[400] leading-tight`}
                  source={CloudDeploymentData?.editor}
                >
                  {CloudDeploymentData?.editor}
                </ReactMarkdown>
              )}
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
}
